// extracted by mini-css-extract-plugin
export default {"wrapper":"FormError_wrapper__1WSKP"};